// extracted by mini-css-extract-plugin
export default {"root":"PhotoListModal_root__3CLz3"};